// extracted by mini-css-extract-plugin
export default {"label-value":"g__label-value--hMLLS","divider":"g__divider--Z4pF2"};